import http from "@/http-common";

class Signup {
  async getSignup(review_id, interval_id) {
    const result = await http.get(
      `reviews/${review_id}/intervals/${interval_id}/signups/`
    );
    return result;
  }

  postSignup(review_id, interval_id, signup) {
    return http.post(
      `reviews/${review_id}/intervals/${interval_id}/signups/`,
      signup
    );
  }

  putSignup(review_id, interval_id, signup_id, signup) {
    console.log(
      `reviews/${review_id}/intervals/${interval_id}/signups/${signup_id}`
    );
    return http.put(
      `reviews/${review_id}/intervals/${interval_id}/signups/${signup_id}`,
      signup
    );
  }

  deleteSignup(review_id, interval_id, signup_id, user_lms_id) {
    return http.delete(
      `reviews/${review_id}/intervals/${interval_id}/signups/${signup_id}/${user_lms_id}`
    );
  }
}

export default new Signup();
